import { UPDATE_VISIBILITY } from "./actions";

interface State {
  isVisible: boolean;
}

const initialState: State = {
  isVisible: false,
};

export const regionSelectionBannerReducer = (state = initialState, action: { type: string; payload: boolean }) => {
  switch (action.type) {
    case UPDATE_VISIBILITY:
      return {
        ...state,
        isVisible: action.payload,
      };
    default:
      return state;
  }
};
